var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"p-0"},[_c('div',{staticClass:"h-100 w-100 no-drag",attrs:{"id":_vm.containerId}})])}
var staticRenderFns = []

export { render, staticRenderFns }